var map = {
	"./cards/birthday-attack-card.wav": 75,
	"./cards/demo-card.wav": 76,
	"./cards/grandma-attack-card.wav": 77,
	"./cards/joker-card.wav": 78,
	"./cards/protection-card.wav": 79,
	"./cards/stop-card.wav": 80,
	"./cards/surprise-meal-card.wav": 81,
	"./cards/switch-friend-card.wav": 82,
	"./cards/switch-stack-card.wav": 83,
	"./cards/trip-attack-card.wav": 84,
	"./cards/virus-card.wav": 85,
	"./effects/background.wav": 86,
	"./effects/bubble.wav": 87,
	"./effects/button.wav": 88,
	"./effects/losing.wav": 89,
	"./effects/move.wav": 90,
	"./effects/tick.wav": 91,
	"./effects/winning.wav": 92,
	"./pages/champions-page.wav": 93,
	"./pages/home-page.wav": 94
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74;